function removeUndefinedFields<T extends Record<string, any>>(obj: T): T {
  Object.keys(obj).forEach((key: keyof T) => {
    if (typeof obj[key] === "undefined") {
      delete obj[key];
    }
  });
  return obj;
}

export default removeUndefinedFields;
